// This file is generated do not modify manually
export const transfers = [
    { path: 'Submitted', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'UpdateStatusButton', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'Rejected', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'Basket', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'Transfer', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'DailyLimit', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'StandingTransfers', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'BulkHeader', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'BulkDomesticForm', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'BulkInternationalForm', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'BulkViewStatus', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'BulkViewStatusForm', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'BulkHeaderDetails', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'BulkTransfersDetails', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'BulkStatusTable', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'BulkUploadResponse', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'CloseAccount', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
    { path: 'PrintTransfers', loadChildren: () =>
    import('./transfers.module').then(m => m.TransfersModule) },
];
